import React from 'react';
import PropTypes from 'prop-types';
import infoIcon from '../../../svgs/info-icon.svg';
import Icon from '../Icon/Icon';
import Tooltip from '../Tooltip/Tooltip';
import './InfoHint.scss';

export default function InfoHint({ title }) {
  return (
    <div>
      <Tooltip largeText title={title}>
        <Icon name="info-icon" />
      </Tooltip>
    </div>
  );
}

InfoHint.propTypes = {
  title: PropTypes.string.isRequired,
};
